import React from 'react'
import { DataBox } from './DataBox'
import { baseSupercargoModel } from '../supercargoModel'
import { PageHeader } from './PageHeader'
import { AddSupercargoModal } from './addSupercargoModal'
import { EditSupercargoModal } from './editSupercargoModal'

export function BaseSupercargo() {
    const { addCarVisible, editCarVisible } = baseSupercargoModel()
    return (
        <>
            <PageHeader />
            <DataBox />
            {addCarVisible && <AddSupercargoModal />}
            {editCarVisible && <EditSupercargoModal />}
        </>
    )
}
